// removed by extract-text-webpack-plugin
module.exports = {"ShowNotificationsButton":"g72jGpf-QV4SnNRj99veg","active":"_3MX9U8o5Bb3O_1jI7n1UBj","UnreadNotificationsDot":"_37PqzFpnPtHvl27nLf-7S8","Header":"_2OWzSn1DqCakcFxPShnGba","HeaderTab":"_2b8uLRIUghqaYW6FUf1nfW","HeaderTitle":"PWIhkNoHhqfMsCNnUR_tO","HeaderCount":"_1gIprO4lAb_f3MdBwCHdKA","Notification":"_14qgf28d06MM6Ov3WkM6NI","TitleText":"_3Ri7QN3_pAEo1AfWj5B9Qe","NotificationBody":"_1S_BuiRphbEVuh3-XcoVq8","BodyPane":"cP7Blx6IfNmCpUsR0EkOx","EmptyStateBody":"UaZd7OyR-kG44wFqLHpPS","Status":"DQfSpHUGDL4qjyPIjm-24","Hr":"_3UhRm10hpdwhA5nxtGnHQ8","Footer":"_1jwI50qLnp6kn2q8LmPpfv"};


//////////////////
// WEBPACK FOOTER
// ./components/WorkspaceNotifications/WorkspaceNotifications.module.css
// module id = 486
// module chunks = 0